import i18n from 'services/base/i18n';

export default {
  stepNameReboot:      () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Name', 'Reboot Pangolin Device'),
  stepNameInstall:     () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Name', 'Fetch and Flash Image'),
  stepNameSwitch:      () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Name', 'Swap and Verify Firmware'),
  stepNameBackup:      () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Name', 'Record Data Snapshot'),

  stepLabelSkipped:    () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Labels', 'Skipped'),
  stepLabelPending:    () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Labels', 'Pending'),
  stepLabelCompleted:  () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Labels', 'Completed'),
  stepLabelInProgress: () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Labels', 'In Progress'),
  stepLabelFailed:     () => i18n.pgettext('Pages|Manage Updates|Upgrade Stepper|Steps|Labels', 'Failed'),
};
